import Vue from 'vue'
import Vuex from 'vuex'
import page from './modules/page'
import user from './modules/user'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    page,
    user,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js